import React from "react";
import { makeRequestAuth } from "../../utils/globals";
import Loader from "../../components/Loader";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import PaymentMethods from "./PaymentMethods";
import ProformaInvoice from "../../components/Modals/ProformaInvoice";
import config from "config";
import profileService from "../../services/profileService";
import PaymentSummary from "./PaymentSummary";
import PayuForm from "./PayuForm";
// import { loadScript } from "@paypal/paypal-js";
import AddCompanyAddressForm from "../../components/AddAddressForm";
import ProfileService from "../../services/profileService";

import axios from "axios";
import { phone_codes } from "../../utils/locales";
import PaymentService from "../../services/PaymentService";
import set from "lodash/set";
import { Primer } from "@primer-io/checkout-web";
import "./createPayment.scss";
import { Row, Col, Container } from "reactstrap";
import {
  Modal,
  Typography,
  Button,
  Input,
  Icon,
  Card,
} from "@plum-xoxo/admin-dsm";
import { app_path, admin_url } from "config";
import styled from "styled-components";
import KybRestrictionMessage from "../../components/KybRestrictionMessage";
import PageHeader from "../../components/styled/PageHeader";
import { CustomCard } from "../Accounts/PlatformPreferences/Component/styled";
import { updateShowCts } from "../../actions/userAction";
import { datas } from "../DiyLogin/components/Counrty";
import SubmitKybForm from "./SubmitKybForm";
import RechargeOtpModal from "../../components/Modals/RechargeOtpModal";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { PaymentElement } from "@stripe/react-stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import debounce from "lodash/debounce";
import BillingDetails from "./BillingDetails";
import { PhoneNumberUtil } from "google-libphonenumber";
import { GATEWAY_ID_TO_NAME_MAPPING } from "./../../constants/PaymentConstant";

const phoneUtil = PhoneNumberUtil.getInstance();
const stripePromise = loadStripe(config.stripe?.promisePublicKey);
// const goBackStyle = {
//   marginBottom: "12px",
//   color: "#5F738C",
//   cursor: "pointer",
//   marginTop: "32px",
// };

const COMPANY_ADDRESS = {
  city_id: "",
  company_address1: "",
  country_id: "",
  state_id: "",
  zip_code: "",
  taxId: "",
};

const COMPANY_ADDRESS_ERROR = {
  city_id: "",
  company_address1: "",
  country_id: "",
  state_id: "",
  zip_code: "",
  taxId: "",
};

const DEFAULT_PAYMENT_FAIL_JSON = {
  payment_error: {
    code: null,
    description: null,
    source: null,
    step: null,
    reason: null,
    order_id: null,
    payment_id: null,
  },
  payment_request: {
    amount: null,
    razorpay_order_id: null,
  },
  sales_order_id: null,
  company_recharge: null,
};

const StyledCard = styled(Card).attrs()`
  background: ${(props) => props.theme.palette.light.c100} !important;
`;

export const getPaymentGatewayFromCurrency = (
  currency = "INR",
  paymentMethod
) => {
  if (currency === "INR") {
    return "razorpay";
  } else if (currency === "USD" && paymentMethod == "ach") {
    return "stripe";
  } else if (currency === "USD") {
    return "primer";
  } else {
    return "payoneer";
  }
};

const StyledModal = styled(Modal).attrs()`
  background: ${(props) => props.theme.palette.background.tertiary};
`;

const BelowPanel = styled.div`
  position: fixed;
  bottom: 0px;
  right: 0px;
  width: 100%;
  height: 76px;
  background: ${(props) => props.theme.palette.light.c000};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.12);
`;

class CreatePayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMsg: "",
      error: false,
      netBankingList: "",
      finaTotal: "",
      markup: 0,
      gst: 0,
      markupPercent: 0,
      formatedNetAmount: "0",
      total: 0,
      loading: false,
      addFundInput: false,
      finalStep: false,
      telephone: "",
      phoneSuccess: "",
      isd_code: "",
      isd_code_object: "",
      companyDetails: "",
      changeHeadline: false,
      errorPhoneNo: false,
      enablePaypal: false,
      currencyCode: props.accountReducer?.userBalance?.currencyCode || "INR",
      discountPercent: 0,
      formatDiscountAmount: "",
      discountAmount: "",
      selectedPayment: "",
      paymentGatewayFeePercent: 0,
      formatedPaymentGatewayAmount: "0",
      formatedMarkupAmount: "0",
      formatedtotal: "",
      showProformaModal: false,
      showProformsSuccess: false,
      showCheckoutLoader: false,
      payuResponse: null,
      rechargeState: {},
      proformaLoader: false,
      payPalButtonloader: false,
      formatedGstAmount: "",
      gstAmount: 0,
      gstPercent: 0,
      companyAddress: COMPANY_ADDRESS,
      errorCompanyAddress: COMPANY_ADDRESS_ERROR,
      countryOption: [],
      stateOption: [],
      cityOption: [],
      selectedCountry: "",
      selectedState: "",
      selectedCity: "",
      companyTaxId: "",
      modified: false,
      errorState: false,
      errorCity: false,
      ipCountryCode: "",
      placeHolder: "",
      addAddresData: true,
      sales_order_id: null,
      razorpay_order_id: null,
      netPayableAmount: "",
      isPaymentFailed: false,
      failedReason: {},
      contact: "",
      otp_id: "",
      nonVerifiedPhoneNumber: "",
      nonVerifiedIsdCodeObject: {},
      bankDetails: {},
      poNumber: "",
      primerModalFail: false,
      countriesLoading: false,
      statesLoading: false,
      citiesLoading: false,
      step: 1,
      razorpayModal: false,
    };
  }

  componentDidMount() {
    this.onGetClientId();
    this.getPGs();
    const {
      accountReducer: {
        userBalance: { currencyCode = "INR" } = {},
        moduleAcl = [],
        employeeDetails: { employee_primary_mobile = "" } = {},
      } = {},
      sales_order_id = null,
      contact = null,
    } = this.props;

    const moduleAclArray = moduleAcl.map((item) => item.module_id) || [];
    const splitNum = employee_primary_mobile.split("-");
    const employeePhnNum = splitNum.length > 1 ? splitNum[1] : "";
    const employeePhnCode = splitNum.length ? splitNum[0] : "";
    const phone_codes_ui =
      phone_codes &&
      phone_codes.map((item) => {
        let obj = item;
        obj.label = item.iso + " " + item.phonecode;
        obj.value = item.country_id;
        return obj;
      });
    const phoneCodeDetails = phone_codes_ui.find(
      (item) => item.phonecode == employeePhnCode
    );
    this.setState({
      moduleAclArray,
      phnNumber: employeePhnNum,
      phone_codes_ui,
      rechargeMaxLimitValue,
    });
    phoneCodeDetails
      ? this.setState({ isd_code_object: phoneCodeDetails })
      : this.getDefaultIsd(phone_codes_ui);

    const rechargeState = this.props.history.location.state
      ? JSON.parse(this.props.history.location.state)
      : {};
    if (this.props.addFund) {
      sessionStorage.setItem("rechargeAmount", parseFloat(this.props.addFund));
      // this.paymentMethod();
    } else {
      this.setState({
        addFundInput: true,
      });
    }
    let tax_country_code;
    const { companyAddress } = this.state;
    if (!tax_country_code) {
      this.getGeoCountryCode();
    }
    const cpyAddress = companyAddress;

    const rechargeMaxLimitValue =
      datas.find((item) => item.code == currencyCode)?.rechargeMaxLimit || 0;
    this.setState({
      companyAddress: cpyAddress,
      rechargeState,
      sales_order_id,
      contact,
      addFund: this.props.addFund,
      rechargeMaxLimitValue: rechargeMaxLimitValue,
    });
    this.initProfile();
    // isCompanyAddressPresent && !this.state.rechargeState.phnNum? <Recharge />:
  }

  setStep = (step) => {
    this.setState({ step });
  };
  initProfile = () => {
    let {
      companyDetails: {
        company_address1,
        company_city_id,
        company_country_id,
        company_zip_code,
        company_state_id,
        company_tax_id,
        company_website,
      } = {},
      employeeDetails: {
        employee_full_name,
        employee_primary_mobile,
        mobile_verified,
      } = {},
    } = this.props.accountReducer;
    // if (!company_country_id || !company_state_id) {
    //   return;
    // }
    let promises = [
      this.getCountryList(),
      company_country_id
        ? this.getStateList(parseInt(company_country_id))
        : null,
      company_state_id ? this.getCityList(parseInt(company_state_id)) : null,
    ];
    this.setState({
      addressLoading: true,
    });
    Promise.all(promises)
      .then(() => {
        let {
          selectedCountry,
          selectedState,
          selectedCity,
          countryOption,
          stateOption,
          cityOption,
        } = this.state;
        selectedCountry = countryOption.filter(
          (country) => country.value == company_country_id
        )[0];
        selectedState = stateOption.filter(
          (state) => state.value == company_state_id
        )[0];
        selectedCity = cityOption.filter(
          (city) => city.value == company_city_id
        )[0];
        let companyAddress = {
          city_id: company_city_id,
          company_address1: company_address1,
          country_id: company_country_id,
          state_id: company_state_id,
          zip_code: company_zip_code,
          company_website: company_website,
          taxId: company_tax_id,
          re_enter_taxId: company_tax_id,
          companyName: this.state.companyAddress.companyName,
        };
        const splitNum = employee_primary_mobile?.split("-");
        const employeePhnNum = splitNum?.length > 1 ? splitNum[1] : "";
        this.setState({
          companyAddress,
          addressLoading: false,
          selectedCountry,
          selectedState,
          selectedCity,
          employeeName: employee_full_name,
          phoneNumber: employeePhnNum,
        });
        if (employeePhnNum !== "") {
          this.setState({
            isMobileVerified: true,
          });
        }
        this.validateTaxtype();
        if (!employeePhnNum) {
          this.setState({ showOtpModal: true });
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  getGeoCountryCode = () => {
    axios.get("https://ipapi.co/json/").then((response) => {
      this.setState({ ipCountryCode: response.data.country_code });
    });
  };
  validateTaxtype = () => {
    const { taxType, countryOption } = this.state;
    if (taxType === "" && countryOption.length > 0) {
      this.getTaxDetails();
    }
  };

  getPhoneCodes = () => {
    const phone_codes_ui =
      phone_codes &&
      phone_codes.map((item) => {
        let obj = item;
        obj.label = item.iso + " " + item.phonecode;
        obj.value = item.country_id;
        return obj;
      });
    this.setState({
      phone_codes_ui,
    });
    this.getDefaultIsd(phone_codes_ui);
  };
  // handleSendOtp = () => {
  //   const { nonVerifiedPhoneNumber, nonVerifiedIsdCodeObject } = this.state;
  //   const phnNumReg = /^(\+\d{1,3}[- ]?)?\d{7,16}$/;
  //   if (!phnNumReg.test(nonVerifiedPhoneNumber)) {
  //     this.setState({
  //       phnNumError: true,
  //     });
  //     return;
  //   }
  //   const {
  //     accountReducer: { userBalance: { currencyCode = "INR" } = {} } = {},
  //   } = this.props;
  //   const otpParams = {
  //     isd_code: nonVerifiedIsdCodeObject.phonecode,
  //     phone_number: nonVerifiedPhoneNumber,
  //   };

  //   this.setState({ addFundsLoader: true });
  //   if (
  //     currencyCode === "INR" &&
  //     nonVerifiedPhoneNumber !== config.skipMobileNumber
  //   ) {
  //     const options = {
  //       query: "storesAdmin.query.generateRechargeOtp",
  //       tag: "storeAdmin",
  //       variables: {
  //         add_data: otpParams,
  //       },
  //     };

  //     makeRequestAuth(
  //       options,
  //       function (response) {
  //         if (
  //           response &&
  //           response.data &&
  //           response.data.generateRechargeOtp &&
  //           response.data.generateRechargeOtp.success === 1
  //         ) {
  //           this.setState({
  //             otp_id: response.data.generateRechargeOtp.otp_id,
  //             showOtpModal: true,
  //             addFundsLoader: false,
  //           });
  //         } else {
  //           NotificationManager.error(
  //             "OTP not sent. Please try again!",
  //             "Error"
  //           );
  //           this.setState({ addFundsLoader: false });
  //         }
  //       }.bind(this)
  //     );
  //   } else {
  //     this.setState(
  //       {
  //         rechargeState: {
  //           phnNum: nonVerifiedPhoneNumber,
  //           isd_code_obj: nonVerifiedIsdCodeObject,
  //           ...this.state.rechargeState,
  //         },
  //       },
  //       this.submitAddressDetails()
  //     );
  //   }
  // };

  handleSendOtp = (event) => {
    event.preventDefault();
    const { phnNumber, isd_code_object } = this.state;
    if (
      !phoneUtil.isValidNumberForRegion(
        phoneUtil.parse(
          `${isd_code_object.phonecode}${phnNumber.trim()}`,
          `${isd_code_object.iso}`
        ),
        `${isd_code_object.iso}`
      )
    ) {
      this.setState({
        phnNumError: true,
        showOtpModal: true,
        addFundsLoader: false,
        renderTurnstileCaptcha: false,
        renderResendTurnstileCaptcha: false,
      });
      return;
    }
    const { accountReducer: { showCts = false } = {} } = this.props;
    this.setState({ addFundsLoader: true });
    // if (this.state.otp_id) return this.proceedToPayment;
    if (
      !(
        this.props.accountReducer?.employeeDetails?.mobile_verified == 1 &&
        this.props.accountReducer?.employeeDetails?.employee_primary_mobile
          ?.length > 6
      ) &&
      phnNumber !== config.skipMobileNumber
    ) {
      // this.proceedToPayment();
      if (showCts) {
        this.setState({
          renderTurnstileCaptcha: true,
        });
      } else {
        this.handleGenerateRechargeOtp();
      }
    } else {
      this.setState({ showOtpModal: false });
    }
  };

  formValidation = () => {
    let { companyAddress, errorCompanyAddress } = this.state;
    if (companyAddress.company_address1.trim() == "") {
      errorCompanyAddress.company_address1 =
        "Please provide a valid business address";
    }
    if (companyAddress.country_id == "") {
      errorCompanyAddress.country_id = "Please Select Country";
    }
    if (companyAddress.state_id == "") {
      errorCompanyAddress.state_id = "Please Select State";
    }
    if (companyAddress.city_id == "") {
      errorCompanyAddress.city_id = "Please Select City";
    }
    if (companyAddress.zip_code == "") {
      errorCompanyAddress.zip_code = "Please enter postal code";
    }
    this.setState({ errorCompanyAddress });
    if (!this.state.rechargeState?.phnNum) {
      this.handleSendOtp();
    } else {
      this.setState({ loading: true });
      this.submitAddressDetails();
    }
  };
  submitAddressDetails = () => {
    let { companyAddress, errorCompanyAddress } = this.state;
    if (
      !Object.keys(errorCompanyAddress).every(
        (ele) => errorCompanyAddress[ele] == ""
      )
    ) {
      this.setState({ loading: false });
      return;
    }
    const request_data = {
      query: "diy.mutation.submit_address_details",
      tag: "diy",
      variables: {
        address: JSON.stringify([
          {
            address: companyAddress.company_address1,
            country_id: companyAddress.country_id,
            state_id: companyAddress.state_id,
            city_id: parseInt(companyAddress.city_id),
            zip_code: companyAddress.zip_code,
          },
        ]),
        gst: companyAddress.taxId,
      },
    };

    makeRequestAuth(request_data, (response) => {
      if (response?.data?.submitAddressDetail?.success === "1") {
        ProfileService.addressDetails({})
          .then((response) => {
            if (response?.fetchCompanyDetails?.company_details?.[0]) {
              this.props.updateCompanyDetails(
                response.fetchCompanyDetails.company_details[0]
              );
            }
          })
          .catch((error) => {
            this.setState({ loader: false });
          });
        this.setState({
          addAddresData: false,
          loading: false,
        });
      } else {
        this.setState({
          errorMsg: response?.data?.submitAddressDetail?.message?.[0],
          loading: false,
          error: true,
        });
        NotificationManager.error(
          response?.data?.submitAddressDetail?.message?.[0]
        );
      }
    });
  };

  getCountryList = () => {
    return new Promise((resolve, reject) => {
      this.setState({ addressLoading: true, countriesLoading: true });
      ProfileService.countryList()
        .then((response) => {
          if (
            response &&
            response.fetchCountries &&
            response.fetchCountries.success &&
            response.fetchCountries.data
          ) {
            let countryOption = [];
            try {
              response.fetchCountries.data.map((country) => {
                country["label"] = country.name;
                country["value"] = country.country_id;
                countryOption.push(country);
              });
              this.setState({ countryOption }, () => {
                resolve({ success: 1, msg: "Success" });
              });
            } catch (err) {
              console.log("error", err);
            }
          } else {
            this.setState({ countryOption: [] });
            resolve({ success: 0, msg: "Fail" });
          }
        })
        .catch((err) => {
          console.log("error in fetch country", err);
        })
        .then(() => {
          this.setState({ addressLoading: false, countriesLoading: false });
        });
    });
  };

  getStateList = (countryId) => {
    return new Promise((resolve, reject) => {
      this.setState({ addressLoading: true, statesLoading: true });
      ProfileService.stateList(countryId)
        .then((response) => {
          if (
            response &&
            response.fetchStates &&
            response.fetchStates.success &&
            response.fetchStates.data
          ) {
            let stateOption = [];
            try {
              response.fetchStates.data.map((state) => {
                state["label"] = state.name;
                state["value"] = state.state_id;
                stateOption.push(state);
              });
              this.setState({ stateOption }, () => {
                resolve({ success: 1, msg: "Success" });
              });
            } catch (err) {
              console.log("error", err);
            }
          } else {
            this.setState({ stateOption: [] });
            resolve({ success: 0, msg: "Fail" });
          }
        })
        .catch((err) => {
          console.log("error in fetch state", err);
        })
        .then(() => {
          this.setState({ addressLoading: false, statesLoading: false });
        });
    });
  };

  getCityList = (stateId) => {
    return new Promise((resolve, reject) => {
      this.setState({ addressLoading: true, citiesLoading: true });
      ProfileService.cityList(stateId)
        .then((response) => {
          if (
            response &&
            response.fetchCities &&
            response.fetchCities.success &&
            response.fetchCities.data
          ) {
            let cityOption = [];
            try {
              response.fetchCities.data.map((city) => {
                city["label"] = city.name;
                city["value"] = city.city_id;
                cityOption.push(city);
              });
              this.setState({ cityOption }, () => {
                resolve({ success: 1, msg: "Success" });
              });
            } catch (err) {
              console.log("error", err);
            }
          } else {
            this.setState({ cityOption: [] });
            resolve({ success: 0, msg: "Fail" });
          }
        })
        .catch((err) => {
          console.log("error in fetch state", err);
        })
        .then(() => {
          this.setState({ addressLoading: false, citiesLoading: false });
        });
    });
  };

  handleInputChange = (tag, event) => {
    const { companyAddress, errorCompanyAddress } = this.state;
    switch (tag) {
      case "taxId":
        const reg = /^[a-zA-Z0-9\.\-\s]{0,15}$/;
        if (!reg.test(event.target.value)) {
          return;
        }
        companyAddress.taxId = event.target.value;
        errorCompanyAddress.taxId = "";
        errorCompanyAddress.re_enter_taxId = "";
        this.setState({ modified: true, companyAddress, errorCompanyAddress });
        break;
      case "country":
        companyAddress.country_id = event.value;
        errorCompanyAddress.country_id = "";
        companyAddress.state_id = "";
        companyAddress.city_id = "";
        companyAddress.zip_code = "";
        this.setState({
          modified: true,
          selectedCountry: event,
          companyAddress,
          selectedCity: "",
          selectedState: "",
          stateOption: [],
          cityOption: [],
        });
        this.getStateList(event.value);
        break;
      case "state":
        companyAddress.state_id = event.value;
        errorCompanyAddress.state_id = "";
        companyAddress.city_id = "";
        companyAddress.zip_code = "";
        this.setState({
          modified: true,
          selectedState: event,
          companyAddress,
          selectedCity: "",
          cityOption: [],
        });
        this.getCityList(event.value);
        break;
      case "city":
        companyAddress.city_id = event.value;
        errorCompanyAddress.city_id = "";
        companyAddress.zip_code = "";
        this.setState({
          modified: true,
          selectedCity: event,
          companyAddress,
        });
        break;
      case "zipcode":
        companyAddress.zip_code = event.target.value;
        errorCompanyAddress.zip_code = "";
        this.setState({ modified: true, companyAddress });
        break;
      case "company_address1":
        companyAddress.company_address1 = event.target.value;
        errorCompanyAddress.company_address1 = "";
        this.setState({ modified: true, companyAddress });
        break;
    }
  };

  updateState = (data) => {
    data = {
      ...data,
      modified: true,
    };
    typeof data === "object" ? this.setState(data) : null;
  };

  setLoader = (loader) => this.setState({ loader });
  setSelectedValue = (selectedOption) => {
    let placeHolder = selectedOption.placeHolder;
    let selectedCountryISO = selectedOption;
    // var taxType = "GST";
    // if (selectedOption.type) {
    //   taxType = selectedOption.type.split("_")[1].toUpperCase();
    // }
    this.setState({
      selectedCountryISO,
      placeHolder,
      modified: true,
    });
  };

  handleValidation = () => {
    const { errorCompanyAddress, companyAddress } = this.state;
    const taxRegex = /^[a-zA-Z0-9\.\-\s]{5,15}$/;

    if (companyAddress.company_address1.trim() == "") {
      errorCompanyAddress.company_address1 =
        "Please provide a valid business address";
    }
    if (companyAddress.country_id == "") {
      errorCompanyAddress.country_id = "Please Select Country";
    }
    if (companyAddress.state_id == "") {
      errorCompanyAddress.state_id = "Please Select State";
    }
    if (companyAddress.city_id == "") {
      errorCompanyAddress.city_id = "Please Select City";
    }
    if (
      companyAddress.zip_code == "" ||
      parseInt(companyAddress.zip_code) == 0
    ) {
      errorCompanyAddress.zip_code = "Please enter postal code";
    }
    if (companyAddress.taxId == "") {
      errorCompanyAddress.taxId = "Please enter Registered ID";
    }
    if (companyAddress.taxId !== "" && !taxRegex.test(companyAddress.taxId)) {
      errorCompanyAddress.taxId = "Please enter correct Registered ID";
    }
    this.setState({ errorCompanyAddress });
    if (
      !Object.keys(errorCompanyAddress).every(
        (ele) => errorCompanyAddress[ele] == ""
      )
    ) {
      return;
    }
  };

  getDefaultIsd = (phone_codes_ui) => {
    profileService.fetchCountryBasedonIP().then((response) => {
      if (response && response.plumApi && response.plumApi.output) {
        const ipBasedOutput = JSON.parse(response.plumApi.output);
        let countryCode = "IN";
        if (ipBasedOutput.success && ipBasedOutput.success === 1) {
          countryCode = ipBasedOutput.country_code;
        }
        const phonecodeDetails = phone_codes_ui.find(
          (item) => item.iso == countryCode
        );
        this.setState({ isd_code_object: phonecodeDetails });
      }
    });
  };

  setPaymentState = (newState, callback = () => {}) => {
    this.setState(newState, () => callback());
  };

  getPaymentGateWay = () => {
    let currencyCode = this.props.accountReducer?.userBalance?.currencyCode
      ? this.props.accountReducer.userBalance.currencyCode
      : "";
    const paymentMethodType = {
      query: "paypal.query.get_payment_gateway",
      tag: "paypal",
      variables: {
        curreny: currencyCode,
      },
    };

    makeRequestAuth(
      paymentMethodType,
      function (response) {
        if (
          response !== undefined &&
          response.data &&
          response.data &&
          response.data.getPaymentGateway
        ) {
          let getPaymentGatewayObj = response.data.getPaymentGateway;
          if (getPaymentGatewayObj.error == false) {
            if (getPaymentGatewayObj.data.payu) {
              this.setState({ enablePaypal: false }, () => {
                this.calculateAmount();
              });
            } else {
              this.setState({ enablePaypal: true }, () => {
                this.calculateAmount();
              });
            }
          } else {
            this.calculateAmount();
            this.setState({
              errorMsg: getPaymentGatewayObj.message[0]
                ? getPaymentGatewayObj.message[0]
                : "Something Went Wrong..",
            });
          }
        } else {
          this.calculateAmount();
          this.setState({
            errorMsg: "Something Went Wrong..",
          });
        }
      }.bind(this)
    );
  };

  paymentMethod = () => {
    this.setState({
      loading: true,
    });
    let method = {
      credit_debit: 1,
      net_banking: 1,
    };

    const paymentMethodType = {
      query: "storesAdmin.mutation.paymentMethod",
      tag: "storeAdmin",
      variables: {
        add_data: method,
      },
    };

    makeRequestAuth(
      paymentMethodType,
      function (response) {
        if (response !== undefined) {
          this.setState({
            netBankingList: response.data.paymentMethod.data.netBanking.banks,
          });
          this.getPaymentGateWay();
          //this.calculateAmount()
        } else {
          this.setState({
            errorMsg: "Something Went Wrong..",
          });
        }
      }.bind(this)
    );
  };

  calculateAmount = (fund = 0, signal = false) => {
    if (!this.state.selectedPayment) {
      return;
    }
    let fundAmount = fund ? Number(fund) : Number(this.props.addFund);
    let amount = {
      gateway_id: this.state.selectedPayment,
      total: parseFloat(fundAmount).toFixed(2),
      markup: parseFloat(0),
      gst: parseFloat(0),
      is_paypal: this.state.enablePaypal ? 1 : 0,
      is_stripe:
        GATEWAY_ID_TO_NAME_MAPPING[this.state.selectedPayment] === "stripe"
          ? 1
          : 0,
    };
    this.setState({ calculateAmountLoader: true });

    PaymentService.calculateAmount(amount, signal)
      .then((response) => {
        if (
          response &&
          response.calculateAmount &&
          response.calculateAmount.error == false
        ) {
          if (signal?.aborted) {
            return;
          }
          this.setState({
            finaTotal: response.calculateAmount.data.total,
            netAmount: response.calculateAmount.data.paymentSummary.netAmount,
            formatedtotal:
              response.calculateAmount.data.paymentSummary.formatedtotal,
            markup: response.calculateAmount.data.paymentSummary.markupAmount,
            markupPercent:
              response.calculateAmount.data.paymentSummary.markupPercent,
            formatedNetAmount:
              response.calculateAmount.data.paymentSummary.formatedNetAmount,
            gstPercent: response.calculateAmount.data.paymentSummary.gstPercent,
            gstAmount: response.calculateAmount.data.paymentSummary.gstAmount,
            formatedMarkupAmount:
              response.calculateAmount.data.paymentSummary.formatedMarkupAmount,
            currencyCode:
              response.calculateAmount.data.paymentSummary.currencyCode,
            formatDiscountAmount:
              response.calculateAmount.data.paymentSummary.formatDiscountAmount,
            discountAmount:
              response.calculateAmount.data.paymentSummary.discountAmount,
            discountPercent:
              response.calculateAmount.data.paymentSummary.discountPercent,
            paymentGatewayFeePercent:
              response.calculateAmount.data.paymentSummary
                .paymentGatewayFeePercent,
            paymentGatewayFee:
              response.calculateAmount.data.paymentSummary.paymentGatewayFee,
            formatedPaymentGatewayAmount:
              response.calculateAmount.data.paymentSummary
                .formatedPaymentGatewayAmount,
            formatedGstAmount:
              response.calculateAmount.data.paymentSummary.formatedGstAmount,
            netPayableAmount:
              response.calculateAmount.data.paymentSummary.total,
            calculateAmountLoader: false,
          });

          //this.rechargeOrder()
          this.setState({ loading: false });
        } else {
          this.setState({
            errorMsg: "Something Went Wrong..",
            error: true,
            calculateAmountLoader: false,
            netPayableAmount: 0,
            netAmount: 0,
            finalTotal: 0,
            formatedNetAmount: "0",
            formatedtotal: "0",
          });
        }
      })
      .catch(() => {
        this.setState({
          calculateAmountLoader: false,
          netPayableAmount: 0,
          netAmount: 0,
          finalTotal: 0,
          formatedNetAmount: "0",
          formatedtotal: "0",
        });
      });

    // if (currencyCode !== "INR") {
    //   setTimeout(() => {
    //     this.initiatePaypalPayment();
    //   }, 1000);
    // }
  };

  createPayuSalesOrder = (amountData) => {
    PaymentService.createPayuRechargeOrder(amountData).then((response) => {
      if (response && response.rechargeOrder) {
        let resp = response.rechargeOrder;

        if (resp.error == false && resp.data && resp.data.order_id) {
          this.setState({
            order_id: resp.data.order_id,
            errorMsg: "",
            otp_id: "",
            error: false,
          });
          this.proceedToPayment();
        } else {
          this.setState({
            showCheckoutLoader: false,
          });
          this.props.history.push(
            this.state.rechargeState?.redirectPage || `/${app_path}/recharge`
          );
          NotificationManager.error(
            response.rechargeOrder.message &&
              response.rechargeOrder.message.length > 0
              ? response.rechargeOrder.message[0]
              : "Something went wrong",
            "Error"
          );
        }
      } else {
        this.setState({
          errorMsg: "Something Went Wrong",
          error: true,
          showCheckoutLoader: false,
        });
      }
    });
  };

  createPayoneerSalesOrder = (amountData) => {
    const payload = { ...amountData };
    const { sales_order_id } = this.state;
    const { company_recharge, is_proforma_invoice } = this.props;
    payload.env = admin_url;
    const isProforma = {
      check: false,
      sales_order_id: null,
    };
    if (is_proforma_invoice === 1) {
      isProforma.check = true;
      isProforma.sales_order_id = sales_order_id;
    }
    payload["isProforma"] = isProforma;
    PaymentService.createSalesOrder(payload).then((response) => {
      if (response && response.createSalesOrder) {
        let resp = response.createSalesOrder;

        if (resp.error == false && resp.sales_order_id) {
          this.setState({
            sales_order_id: resp.sales_order_id,
            errorMsg: "",
            otp_id: "",
            error: false,
          });
          const payoneerResp = JSON.parse(resp.token || "{}");
          localStorage.setItem(
            "payoneerRedirectPath",
            this.state.rechargeState?.redirectPage || `/${app_path}/recharge`
          );
          localStorage.setItem(
            "payoneerRechargeOrigin",
            company_recharge == "2" ? "plumPro" : "plum"
          );
          localStorage.setItem("payoneerRechargeCompanyType", company_recharge);
          localStorage.setItem(
            "payoneerRechargeAmount",
            amountData?.total || 0
          );
          window.open(resp.redirectUrl, "_self");
        } else {
          this.setState({
            showCheckoutLoader: false,
          });
          // setTimeout(
          //   () =>
          //     this.props.history.push(
          //       this.state.rechargeState?.redirectPage ||
          //         `/${app_path}/recharge`
          //     ),
          //   5000
          // );
          NotificationManager.error(
            response.createSalesOrder.message &&
              response.createSalesOrder.message.length > 0
              ? response.createSalesOrder.message
              : "Something went wrong",
            "Error"
          );
        }
      } else {
        this.setState({
          errorMsg: "Something Went Wrong",
          error: true,
          showCheckoutLoader: false,
        });
      }
    });
  };

  createRazorpaySalesOrder = (amountData) => {
    const { paymentGatewayFeePercent = 0, sales_order_id } = this.state;
    const { is_proforma_invoice } = this.props;
    const isProforma = {
      check: false,
      sales_order_id: null,
    };
    if (is_proforma_invoice === 1) {
      isProforma.check = true;
      isProforma.sales_order_id = sales_order_id;
    }
    amountData["isProforma"] = isProforma;
    amountData["payment_gateway_fee"] = parseFloat(
      paymentGatewayFeePercent
    ).toFixed(0);
    PaymentService.createSalesOrder(amountData).then((response) => {
      if (response && response.createSalesOrder) {
        let resp = response.createSalesOrder;

        if (resp.error == false && resp.sales_order_id) {
          this.setState({
            sales_order_id: resp.sales_order_id,
            razorpay_order_id: resp.token,
            errorMsg: "",
            otp_id: "",
            error: false,
          });
          this.razorpayCheckout();
        } else {
          NotificationManager.error(resp.message, "Error");
          this.setState({
            showCheckoutLoader: false,
          });
          setTimeout(() => {
            this.props.history.push(
              this.state.rechargeState?.redirectPage || `/${app_path}/recharge`
            );
          }, 500);
        }
      } else {
        NotificationManager.error("Error in creating Sales Order ID", "Error");
        this.setState({
          errorMsg: "Something Went Wrong",
          error: true,
          showCheckoutLoader: false,
        });
      }
    });
  };

  createPrimerSalesOrder = (amountData) => {
    const { paymentGatewayFeePercent = 0, sales_order_id } = this.state;
    const { is_proforma_invoice } = this.props;
    const isProforma = {
      check: false,
      sales_order_id: null,
    };
    if (is_proforma_invoice === 1) {
      isProforma.check = true;
      isProforma.sales_order_id = sales_order_id;
    }
    amountData["isProforma"] = isProforma;
    amountData["payment_gateway_fee"] = parseFloat(
      paymentGatewayFeePercent
    ).toFixed(0);
    PaymentService.createPrimerSalesOrder(amountData).then((response) => {
      if (response && response.createSalesOrder) {
        let resp = response.createSalesOrder;

        if (!resp.error && resp.sales_order_id && resp.token) {
          const token = JSON.parse(resp.token)["clientToken"];
          this.setState({
            sales_order_id: resp.sales_order_id,
            primerToken: token,
            errorMsg: "",
            otp_id: "",
            error: false,
          });
          this.primerCheckout();
        } else {
          NotificationManager.error(resp.message, "Error");
          this.setState({
            showCheckoutLoader: false,
          });
          setTimeout(() => {
            this.props.history.push(
              this.state.rechargeState?.redirectPage || `/${app_path}/recharge`
            );
          }, 500);
        }
      } else {
        NotificationManager.error("Error in creating Sales Order ID", "Error");
        this.setState({
          errorMsg: "Something Went Wrong",
          error: true,
          showCheckoutLoader: false,
        });
      }
    });
  };

  createStripeSalesOrder = (amountData) => {
    const { paymentGatewayFeePercent = 0, sales_order_id } = this.state;
    const { finaTotal = 0, netPayableAmount, primerToken } = this.state;
    const redirectPage = this.state.rechargeState?.redirectPage || "";
    const currencyCode = this.props.accountReducer?.userBalance?.currencyCode;
    const { company_recharge } = this.props;
    const { is_proforma_invoice } = this.props;
    const isProforma = {
      check: false,
      sales_order_id: null,
    };
    if (is_proforma_invoice === 1) {
      isProforma.check = true;
      isProforma.sales_order_id = sales_order_id;
    }
    amountData["isProforma"] = isProforma;
    amountData["payment_gateway_fee"] = parseFloat(
      paymentGatewayFeePercent
    ).toFixed(0);
    amountData["pathname"] = `/${app_path}/stripe-recharge-callback/`;
    amountData["state"] = JSON.stringify({
      company_recharge: parseInt(company_recharge),
      amount: finaTotal * 100,
      status: "success",
      origin: company_recharge == "2" ? "plumPro" : "plum",
      netPayableAmount,
      redirectPage: redirectPage,
      currencyCode: currencyCode,
      primerToken: primerToken,
    });
    PaymentService.createStripeSalesOrder(amountData).then((response) => {
      if (response && response?.createSalesOrder) {
        let resp = response?.createSalesOrder;

        if (!resp.error && resp.token) {
          const token = resp.token;
          this.setState({
            sales_order_id: resp.sales_order_id,
            stripeToken: token,
            errorMsg: "",
            otp_id: "",
            error: false,
          });
          this.stripeCheckout();
        } else {
          NotificationManager.error(resp.message, "Error");
          this.setState({
            showCheckoutLoader: false,
          });
          setTimeout(() => {
            this.props.history.push(
              this.state.rechargeState?.redirectPage || `/${app_path}/recharge`
            );
          }, 500);
        }
      } else {
        NotificationManager.error("Error in creating Sales Order ID", "Error");
        this.setState({
          errorMsg: "Something Went Wrong",
          error: true,
          showCheckoutLoader: false,
        });
      }
    });
  };

  proceedToPayment = () => {
    const {
      accountReducer: { userBalance: { currencyCode = "INR" } = {} } = {},
    } = this.props;

    if (currencyCode === "INR") {
      this.razorpayCheckout();
    } else if (currencyCode === "USD" && this.state.selectedPayment == "ach") {
      this.stripeCheckout();
    } else if (currencyCode === "USD") {
      this.primerCheckout();
    }
  };

  handlePaymentFail = () => {
    const {
      razorpay_order_id = null,
      sales_order_id,
      isPaymentFailed,
      failedReason,
      finaTotal,
    } = this.state;
    const { company_recharge } = this.props;
    const fundAmount = Number(this.props.addFund);
    this.setState({ razorpayModal: false });
    let paymentFailParams = DEFAULT_PAYMENT_FAIL_JSON;
    if (isPaymentFailed) {
      set(paymentFailParams.payment_error, "code", failedReason.code);
      set(
        paymentFailParams.payment_error,
        "description",
        failedReason.description
      );
      set(paymentFailParams.payment_error, "source", failedReason.source);
      set(paymentFailParams.payment_error, "step", failedReason.step);
      set(paymentFailParams.payment_error, "reason", failedReason.reason);
      set(
        paymentFailParams.payment_error,
        "order_id",
        failedReason.metadata.order_id
      );
      set(
        paymentFailParams.payment_error,
        "payment_id",
        failedReason.metadata.payment_id
      );
      set(
        paymentFailParams.payment_error,
        "payment_id",
        failedReason.metadata.payment_id
      );
    } else {
      set(
        paymentFailParams,
        "payment_error.description",
        "Payment cancelled by user"
      );
    }
    set(paymentFailParams.payment_error, "order_id", razorpay_order_id);
    set(paymentFailParams.payment_request, "amount", finaTotal);
    set(
      paymentFailParams.payment_request,
      "razorpay_order_id",
      razorpay_order_id
    );
    paymentFailParams.sales_order_id = sales_order_id;
    paymentFailParams.company_recharge = company_recharge;
    PaymentService.updateRazorpayPaymentFail(paymentFailParams).then(
      (response) => {
        if (
          response.updatePaymentFail &&
          Object.keys(response.updatePaymentFail).length === 0
        ) {
          throw new Error("Error in cancelling sales order");
        } else {
          this.setState(
            {
              showCheckoutLoader: false,
              isPaymentFailed: false,
              failedReason: {},
            },
            () =>
              this.props.history.push({
                pathname:
                  `/${app_path}/razorpay-payment-status/fail/` + sales_order_id,
                state: JSON.stringify({
                  order_id: sales_order_id,
                  status: "fail",
                  origin: company_recharge == "2" ? "plumPro" : "plum",
                  amount: fundAmount,
                  finaTotal,
                  rechargeFailReason: isPaymentFailed
                    ? failedReason.description
                    : "Payment cancelled by user",
                  redirectPath: this.state.rechargeState?.redirectPage,
                  company_recharge: company_recharge,
                }),
              })
          );
        }
      }
    );
  };

  razorpayCheckout = () => {
    const {
      razorpay_order_id = null,
      finaTotal = 0,
      rechargeState: {
        phnNum = "",
        isd_code_obj: { phonecode = "" } = {},
      } = {},
      telephone,
      isd_code,
      sales_order_id,
      netPayableAmount,
      currencyCode,
      formatedtotal,
    } = this.state;
    const {
      accountReducer: {
        employeeDetails: {
          employee_email = "",
          employee_primary_mobile = "",
        } = {},
      } = {},
      company_recharge,
    } = this.props;
    if (!razorpay_order_id) {
      NotificationManager.error("Razorpay Order ID is missing", "Error");
      throw new Error("Razorpay Order ID is missing");
    }
    let userMobile = "";
    if (phnNum.length > 0 && phonecode.length > 0) {
      userMobile = phonecode + "-" + phnNum;
    } else if (isd_code.length > 0 && telephone.length > 0) {
      userMobile = isd_code + "-" + telephone;
    } else {
      userMobile = employee_primary_mobile;
    }
    const razorpayOptions = {
      key: config.razorpay_key,
      amount: finaTotal,
      currency: "INR",
      name: "Xoxoday",
      description: razorpay_order_id,
      order_id: razorpay_order_id,
      handler: (response) => {
        this.setState({ razorpayModal: false });
        this.props.history.push({
          pathname:
            `/${app_path}/razorpay-recharge-callback/` + razorpay_order_id,
          state: JSON.stringify({
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            company_recharge: parseInt(company_recharge),
            amount: parseFloat(formatedtotal.split(" ")[1]).toFixed(2) * 100,
            status: "success",
            origin: company_recharge == "2" ? "plumPro" : "plum",
            sales_order_id,
            netPayableAmount,
            finaTotal,
            currency: currencyCode,
            redirectPage: this.state.rechargeState?.redirectPage,
          }),
        });
        // alert(response.razorpay_payment_id);
        // alert(response.razorpay_order_id);
        // alert(response.razorpay_signature);
      },
      prefill: {
        email: employee_email,
        contact: userMobile,
      },
      modal: {
        confirm_close: true,
        ondismiss: () => {
          this.handlePaymentFail();
        },
      },
    };
    if (
      this.props.accountReducer?.kybStatus?.kyb_status !== 2 ||
      this.props.accountReducer?.ccRechargeAllowed != 1
    ) {
      razorpayOptions.config = {
        display: {
          blocks: {
            banks: {
              name: "All payment methods",
              instruments: [
                {
                  method: "upi",
                },
                {
                  method: "wallet",
                },
                {
                  method: "netbanking",
                },
              ],
            },
          },
          sequence: ["block.banks"],
          preferences: {
            show_default_blocks: false,
          },
        },
      };
    }
    this.setState({ razorpayModal: true });
    var rzpEvent = new window.Razorpay(razorpayOptions);
    rzpEvent.on("payment.failed", (response) => {
      this.setState({
        failedReason: response.error,
        isPaymentFailed: true,
        razorpayModal: false,
      });
    });
    rzpEvent.open();
  };

  primerCheckout = () => {
    const { finaTotal = 0, netPayableAmount, primerToken } = this.state;
    const { history } = this.props;
    const redirectPage = this.state.rechargeState?.redirectPage || "";
    const currencyCode = this.props.accountReducer?.userBalance?.currencyCode;
    const { company_recharge } = this.props;
    if (!primerToken) {
      NotificationManager.error("Primer Token is missing", "Error");
      throw new Error("Primer Token is missing");
    }

    const primerOptions = {
      container: "#checkout-container",
      onCheckoutComplete(response) {
        const { payment } = response;
        const { id, orderId } = payment;
        history.push({
          pathname: `/${app_path}/primer-recharge-callback/` + orderId,
          state: JSON.stringify({
            orderId: orderId,
            paymentId: id,
            company_recharge: parseInt(company_recharge),
            amount: finaTotal * 100,
            status: "success",
            origin: company_recharge == "2" ? "plumPro" : "plum",
            sales_order_id: orderId,
            netPayableAmount,
            redirectPage: redirectPage,
            currencyCode: currencyCode,
            primerToken: primerToken,
          }),
        });
      },
      submitButton: {
        amountVisible: true,
      },
      style: {
        background: "white",
        minWidth: "30%",
        inputErrorText: {
          fontFamily: "courier new",
          textAlign: "left",
          color: "#e70909",
        },
        inputLabel: {
          fontFamily: "Inter",
          color: "#5F738C",
          fontStyle: "normal",
          fontWeight: 400,
          fontSize: "16px",
          lineHeight: "24px",
        },
        input: {
          base: {
            background: "#ffffff",
            fontFamily: "sans-serif",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "16px",
            /* White */
            /* Ink / Lighter */

            borderStyle: "solid solid solid solid",
            borderColor: "#BAC7D5",
            borderRadius: "4px",
            lineHeight: "24px",
            color: "#000000",
            height: "58px",
            error: {
              borderStyle: "solid",
              borderColor: "#d0021b",
              fontFamily: "Inter",
              fontStyle: "normal",
              fontSize: "16px",
            },
          },
        },
        submitButton: {
          base: {
            background: "#C7417B",
            borderRadius: "4px",
          },
        },
      },
    };
    this.setState({ isPrimerOpen: true }, () =>
      Primer.showUniversalCheckout(primerToken, primerOptions)
    );
  };

  stripeCheckout = () => {
    this.setState({ showCheckoutLoader: true });
    // open stripe checkout
  };

  rechargeOrder() {
    if (
      this.props.company_recharge != 0 &&
      this.props.company_recharge != 1 &&
      this.props.company_recharge != 2
    ) {
      NotificationManager.error("Please provide Fund type", "Error");
      return;
    }
    const {
      accountReducer: {
        employeeDetails: { employee_primary_mobile = "" } = {},
      },
    } = this.props;
    const { is_proforma_invoice } = this.props;

    this.setState({ showCheckoutLoader: true });

    const amount = {
      total: parseFloat(this.state.finaTotal).toFixed(2),
      markup: parseFloat(this.state.markupPercent),
      discount: parseFloat(this.state.discountPercent),
      gst: parseFloat(this.state.gstPercent),
      company_recharge: parseInt(this.props.company_recharge),
      mobile: employee_primary_mobile,
      gateway_id: parseInt(this.state.selectedPayment),
    };

    const paymentGateway =
      GATEWAY_ID_TO_NAME_MAPPING[this.state.selectedPayment];
    if (paymentGateway === "razorpay") {
      this.createRazorpaySalesOrder(amount);
    } else if (paymentGateway === "payoneer") {
      this.createPayoneerSalesOrder(amount);
    } else if (
      paymentGateway === "stripe" ||
      paymentGateway === "stripe_wire"
    ) {
      this.createStripeSalesOrder(amount);
    } else if (paymentGateway === "primer") {
      this.createPrimerSalesOrder(amount);
    }
  }

  proformaInvoice = () => {
    const { currencyCode } = this.state;
    const { history } = this.props;
    this.setState(({ showProformaModal }) => ({
      showProformaModal: !showProformaModal,
    }));
  };

  handleOnlinePayment = () => {
    const { accountReducer } = this.props;
    const paymentGateway =
      GATEWAY_ID_TO_NAME_MAPPING[this.state.selectedPayment];

    if (
      (!accountReducer.companyDetails ||
        !accountReducer.companyDetails.company_address1) &&
      this.addAddresData
    ) {
      return;
    }
    if (
      accountReducer?.userBalance?.currencyCode === "" ||
      accountReducer?.userBalance?.currencySymbol === ""
    ) {
      NotificationManager.error(
        "There is no base/transacting  currency set up for your account. Please contact your account manager to set it up for you, before initiating recharge",
        "Failure"
      );
      return;
    }
    if (!paymentGateway) {
      NotificationManager.error("Error in initiating payment gateway", "Error");
      return;
    }
    this.rechargeOrder();
  };

  payoneerCheckout = () => {};

  payuCheckout = () => {
    var payuData;

    const {
      sales_order_id = 0,
      is_proforma_invoice = 0,
      company_recharge,
    } = this.props;

    const orderId =
      is_proforma_invoice === 1 && sales_order_id != 0
        ? sales_order_id
        : this.state.order_id;

    if (is_proforma_invoice === 1) {
      this.setState({ showCheckoutLoader: true });
    }

    if (company_recharge === 2) {
      payuData = {
        order_id: parseInt(orderId),
        surl: config.node_server + "payu-response-res-fund?status=success",
        furl: config.node_server + "payu-response-res-fund?status=fail",
        curl: config.node_server + "payu-response-res-fund?status=cancel",
        bank_code: this.state.paymentType == "NB" ? this.state.bankCode : "CC",
        pg: this.state.paymentType || "CC",
        udf1: this.state.rechargeState?.redirectPage || this.props.udfUrl || "",
        company_recharge: company_recharge,
      };
    } else {
      payuData = {
        order_id: parseInt(orderId),
        surl: config.node_server + "payu-response?status=success",
        // surl:location.origin+"/admin/recharge-callback/",
        furl: config.node_server + "payu-response?status=fail",
        curl: config.node_server + "payu-response?status=cancel",
        bank_code: this.state.paymentType == "NB" ? this.state.bankCode : "",
        pg: this.state.paymentType || "CC",
        udf1: this.state.rechargeState?.redirectPage || this.props.udfUrl || "",
        company_recharge: company_recharge,
      };
    }

    const payuDataSend = {
      query: "storesAdmin.mutation.payuCheckout",
      tag: "storeAdmin",
      variables: {
        add_data: payuData,
      },
    };

    makeRequestAuth(payuDataSend, (response) => {
      this.setState({ showCheckoutLoader: false });
      if (
        response &&
        response.data &&
        response.data.payuCheckout &&
        response.data.payuCheckout.error === false
      ) {
        this.setState(
          {
            payuResponse: response.data.payuCheckout.data,
            showCheckoutLoader: false,
          },
          () => {
            this.payUpayment();
          }
        );
      } else {
        this.setState({
          errorMsg: "Something Went Wrong..",
          error: true,
        });
      }
    });
  };

  payUpayment = () => {
    document.getElementById("payuForm").submit();
    var formdata = document.getElementById("payuForm");
  };

  generateInvoice = () => {
    this.setState({ proformaLoader: true });
    const {
      product_type,
      accountReducer: {
        employeeDetails: {
          employee_email = "",
          employee_primary_mobile = "",
        } = {},
      } = {},
    } = this.props;
    const { addFund } = this.state;
    const {
      markupPercent,
      discountPercent,
      rechargeState: {
        isd_code_obj: { phonecode = "" } = {},
        phnNum = "",
      } = {},
      gstPercent,
      poNumber,
    } = this.state;
    const email = employee_email;
    const data = {
      total: addFund,
      product_type: product_type,
      email: email,
      mobile: employee_primary_mobile,
      discount: discountPercent,
      markup: markupPercent,
      gst: parseInt(gstPercent),
      po_number: poNumber,
      otp_id: this.props.otp_id,
    };
    profileService.proformaInvoice(data).then((response) => {
      if (
        response !== undefined &&
        response.data &&
        response.data.getProformaInvoice &&
        response.data.getProformaInvoice.status
      ) {
        this.setState({
          proformaOrderId: response.data.getProformaInvoice.data.order_id,
          statusMessage: response.data.getProformaInvoice.statusMessage,
          showProformaModal: false,
          showProformsSuccess: true,
          proformaLoader: false,
        });
        this.handleProformaSubmit();
      } else {
        this.setState({
          statusMessage: response.data.getProformaInvoice.statusMessage,
          showProformaModal: false,
          showProformsSuccess: false,
          proformaLoader: false,
        });
        NotificationManager.error(
          response.data.getProformaInvoice.statusMessage,
          "Failure"
        );
      }
    });
  };

  handleProformaSubmit = () => {
    const {
      accountReducer: { employeeDetails: { employee_email = "" } = {} } = {},
      product_type,
    } = this.props;
    const state = JSON.stringify({
      showProformsSuccess: true,
      employee_email: employee_email,
    });
    this.props.history.push({
      pathname: `/${app_path}/recharge/`,
      title: "transaction-history",
    });
    this.setState({
      showProformsSuccess: false,
      showProformaModal: false,
    });
  };

  handleISDchange = (event) => {
    this.setState({
      isd_code_object: event,
      isd_code: event.phonecode,
      error: false,
      errorMsg: "",
    });
  };

  componentWillReceiveProps(nextProps) {
    if (this.state.telephone == "" && nextProps.contact) {
      let contact = nextProps.contact.split("-");
      this.setState({
        telephone: contact[1] ? contact[1] : contact[0],
        isd_code: contact[1] ? contact[0] : "",
      });
    }
  }

  getClientID = (currencycode) => {
    return new Promise((resolve) => {
      const paymentMethodType = {
        query: "paypal.query.get_client_id",
        tag: "paypal",
        variables: {
          curreny: currencycode,
        },
      };
      makeRequestAuth(paymentMethodType, function (response) {
        if (response.data) {
          resolve(response.data);
        } else {
          resolve(0);
        }
      });
    });
  };

  onPressBack = () => {
    this.setState({ primerModalFail: true });
  };

  handleCancelPayment = (redirectPage) => {
    const { company_recharge } = this.props;
    const {
      primerToken,
      paymentId,
      currencyCode,
      sales_order_id,
      netPayableAmount,
    } = this.state;
    const paymentStatusOptions = {
      primer_payment_request: primerToken,
      primer_payment_response: {
        id: paymentId,
        status: "CANCELLED",
        currencyCode: currencyCode,
        orderId: sales_order_id,
        amount: netPayableAmount,
      },
      amount: parseFloat(netPayableAmount) * 100,
      company_recharge,
    };

    PaymentService.updatePrimerPayment(paymentStatusOptions).then(() => {
      this.props.history.push({
        pathname: `/${app_path}/primer-payment-status/fail/` + sales_order_id,
        state: JSON.stringify({
          origin: origin,
          order_id: sales_order_id,
          status: "fail",
          amount: parseFloat(this.state.finaTotal).toFixed(2),
          company_recharge,
          rechargeFailReason: "user cancellation",
          redirectPath: redirectPage || `/${app_path}/recharge/`,
        }),
      });
    });
  };

  // onCreateOrderApiCall(orderId) {
  //   const {
  //     rechargeState: {
  //       isd_code_obj: { phonecode = "" } = {},
  //       phnNum = "",
  //     } = {},
  //     telephone,
  //     isd_code,
  //   } = this.state;
  //   const {
  //     accountReducer: {
  //       employeeDetails: { employee_primary_mobile = "" } = {},
  //     } = {},
  //   } = this.props;
  //   return new Promise((resolve, reject) => {
  //     let mobile = "";
  //     if (phnNum.length > 0 && phonecode.length > 0) {
  //       mobile = phonecode + "-" + phnNum;
  //     } else if (isd_code.length > 0 && telephone.length > 0) {
  //       mobile = isd_code + "-" + telephone;
  //     } else {
  //       mobile = employee_primary_mobile;
  //     }
  //     const query = "paypal.mutation.create_order";
  //     const request_data = {
  //       query,
  //       tag: "paypal",
  //       variables: {
  //         add_data: {
  //           total: parseFloat(this.state.finaTotal).toFixed(2),
  //           company_recharge: parseInt(this.props.company_recharge),
  //           mobile: mobile,
  //           markup: parseFloat(this.state.markupPercent).toFixed(2),
  //           otp_id: "",
  //           otp: "",
  //           payment_gateway_fee: parseFloat(
  //             this.state.paymentGatewayFeePercent
  //           ).toFixed(2),
  //           discount: parseFloat(this.state.discountPercent).toFixed(2),
  //           gst: parseFloat(this.state.gstPercent).toFixed(2),
  //         },
  //       },
  //     };
  //     makeRequestAuth(request_data, function (response) {
  //       if (response.data) {
  //         resolve(response);
  //       } else {
  //         resolve(0);
  //       }
  //     });
  //   });
  // }

  createOrder() {
    return this.onCreateOrderApiCall("ghjkjhvcvn").then((response) => {
      this.setState({ loader: false });
      if (response) {
        if (response.data.createOrder.error == false) {
          this,
            this.setState({
              paypal_order_id: response.data.createOrder.paypal_order_id
                ? response.data.createOrder.paypal_order_id
                : "",
              paypal_sales_order_id: response.data.createOrder.sales_order_id
                ? response.data.createOrder.sales_order_id
                : "",
              paypal_currency: response.data.createOrder.currency
                ? response.data.createOrder.currency
                : "",
            });
          return response.data.createOrder.paypal_order_id
            ? response.data.createOrder.paypal_order_id
            : "";
        } else {
          let errorMeessage = response.data.createOrder.message
            ? response.data.createOrder.message[0]
            : "Something went wrong, Please try again. ";
          NotificationManager.error(errorMeessage, "Failure");
          return "";
        }
      } else {
        NotificationManager.error(
          "Something went wrong, Please try again. ",
          "Failure"
        );
        return "";
      }
    });
  }

  onApproveOrderApiCall(orderId) {
    return new Promise((resolve) => {
      const query = "paypal.mutation.approver_order";
      const request_data = {
        query,
        tag: "paypal",
        variables: {
          add_data: {
            paypal_order_id: orderId,
            order_id: this.state.paypal_sales_order_id || "",
            currency: this.state.paypal_currency || "",
          },
        },
      };
      makeRequestAuth(request_data, function (response) {
        if (response.data) {
          resolve(response.data);
        } else {
          resolve(response);
          // NotificationManager.error('Failed to authenticate', 'Failure')
        }
      });
    });
  }

  onApprove(data) {
    let order_Id = btoa(data.orderID);
    this.setState({ onapproveLoading: true });
    const { company_recharge = "", udfUrl = "" } = this.props;
    return this.onApproveOrderApiCall(data.orderID).then((response) => {
      this.setState({ onapproveLoading: false });
      if (response.approverOrder.error == false) {
        this.props.history.push({
          pathname: `/${app_path}/paypal-recharge-callback/` + order_Id,
          state: JSON.stringify({
            order_id: data.orderID,
            status: "success",
            company_recharge: company_recharge,
            callbackUrl: udfUrl,
            origin: company_recharge == "2" ? "plumPro" : "plum",
            sales_order_id: this.state.paypal_sales_order_id,
            amount: this.state.rechargeState.amount,
          }),
        });
      } else if (
        response.approverOrder.error &&
        response.approverOrder.errorCode == 101
      ) {
        // loadScript({
        //   "client-id": this.state.client_Id,
        //   currency: this.state.currencyCode,
        // })
        //   .then((paypal) => {
        //     const this1 = this;
        //     paypal
        //       .Buttons({
        //         createOrder: function (data, actions) {
        //           return this1.createOrder(data, actions);
        //         },
        //         onApprove: function (data, actions) {
        //           return this1.onApprove(data, actions);
        //         },
        //       })
        //       .render("#paypal-button-container");
        //   })
        //   .catch((err) => {
        //     console.error("failed to load the PayPal JS SDK script", err);
        //   });
        NotificationManager.error(
          "Insufficient balance ,please try other mode of payment",
          "Failure"
        );
      } else {
        this.props.history.push({
          pathname: `/${app_path}/paypal-payment-status/fail/` + order_Id,
          state: JSON.stringify({
            order_id: data.orderID,
            status: "fail",
            callbackUrl: udfUrl,
            origin: company_recharge == "2" ? "plumPro" : "plum",
            rechargeFailReason:
              response.approverOrder.error_description ||
              "cannot initiate payment",
          }),
        });
      }
    });
  }
  getPGs = async () => {
    this.setState({ pgsLoading: true });
    const pgs = await PaymentService.getPGs();
    const pgOptions = pgs?.getPGs?.data || [];
    const pgMap = {};
    pgOptions?.map((pg) => {
      if (pg) {
        pgMap[pg.gatewayId] = pg;
      }
    });
    this.setState({ pgs: pgOptions, pgMap: pgMap, pgsLoading: false });
  };

  onGetClientId = () => {
    this.setState({ loader: true });

    profileService
      .getClientId({})
      .then((response) => {
        if (
          response &&
          response.getClientId &&
          response.getClientId.status == true &&
          response.getClientId.data
        ) {
          const {
            billing_entity_name,
            bank_name,
            account_no,
            ifsc_code,
            swift_code,
            iban_number,
            sort_code,
            micr_code,
            routing_code,
            ad_code,
            bic_code,
            branch_code,
            bank_code,
          } = response.getClientId.data.bank_details;
          this.setState({
            bankDetails: {
              account_name: billing_entity_name,
              bank_name: bank_name,
              account_no: account_no,
              ifsc_code: ifsc_code,
              swift_code: swift_code,
              iban_number: iban_number,
              sort_code: sort_code,
              micr_code: micr_code,
              routing_code: routing_code,
              ad_code: ad_code,
              bic_code: bic_code,
              branch_code: branch_code,
              bank_code: bank_code,
            },
            loader: false,
          });
        }
        updateShowCts(response.getClientId.showCts || false);
        // this.props.updateClientId(response.getClientId.data.client_id);
        this.props.updateKybStatus(response.getClientId.data);
        this.setState({ isAddressLoading: true });
        ProfileService.addressDetails({}).then((response) => {
          this.setState({ isAddressLoading: false });
          if (response?.fetchCompanyDetails?.company_details?.[0]) {
            this.props.updateCompanyDetails(
              response.fetchCompanyDetails.company_details[0]
            );
          }
        });
      })
      .catch(() => {
        this.setState({ loader: false });
        NotificationManager.error("Unable to fetch Client Id details", "Error");
      });
  };

  onChangePONumber = (e) => {
    this.setState({ poNumber: e.target.value });
  };

  handleAmountChange = (event) => {
    const {
      accountReducer: { userBalance: { currencyCode = "INR" } = {} } = {},
    } = this.props;
    const { rechargeMaxLimitValue } = this.state;
    if (event && event.target) {
      let amount = event.target.value.replace(/[^a-zA-Z0-9]/g, "");
      let reg = /^\d+$/;

      if (
        !(amount.length == 0 && amount == "") &&
        (!reg.test(amount) || parseInt(amount) == 0)
      ) {
        return;
      }
      if (
        parseInt(amount) >
        this.state.pgMap?.[this.state.selectedPayment]?.maxLimit
      ) {
        this.setState({
          maxAmountError: `Amount should be less than or equal to ${
            Number(this.state.pgMap?.[this.state.selectedPayment]?.maxLimit)
              ?.toFixed(2)
              ?.replace(/\d(?=(\d{3})+\.)/g, "$&,") || 0
          }
           for selected payment method.`,
        });
      } else {
        this.setState({
          maxAmountError: false,
        });
      }

      this.setState({
        addFund: parseInt(amount) ? parseInt(amount) : "",
      });
      sessionStorage.setItem("rechargeAmount", parseFloat(amount));
      const abortController = new AbortController();
      this.state.selectedPayment &&
        this.debouncedCalculateAmount(amount, abortController.signal);
    }
  };
  debouncedCalculateAmount = debounce(this.calculateAmount, 500);

  handleMobileChange = (event) => {
    if (event && event.target) {
      let phnNum = event.target.value;

      if (
        !(phnNum.length == 0 && phnNum == "") &&
        !/^[1-9][\d]{0,15}$/gm.test(phnNum)
      ) {
        return;
      }
      this.setState({
        phnNumError: false,
        phnNumber: phnNum ? phnNum : "",
      });
    }
  };

  handleGenerateRechargeOtp = (token = "") => {
    const { phnNumber, isd_code_object } = this.state;
    const otpParams = {
      phone_code: isd_code_object.phonecode,
      phone: phnNumber,
      token,
      mobile_verified: 0,
    };
    // const options = {
    //   query: "storesAdmin.query.generateRechargeOtp",
    //   tag: "storeAdmin",
    //   variables: {
    //     add_data: otpParams,
    //   },
    // };
    const options = {
      query: "stores.mutation.update_employee_data",
      tag: "stores",
      variables: {
        update_data: JSON.stringify(otpParams),
      },
    };

    makeRequestAuth(
      options,
      function (response) {
        if (response?.data?.updateDetails?.otp_success === 1) {
          if (!response?.data?.updateDetails?.otp_id) {
            this.setState({ loader: true });
            this.props.updateEmployeeDetails({
              ...this.props.accountReducer.userDetails,
              employee_primary_mobile:
                otpParams.phone_code + "-" + otpParams.phone,
              mobile_verified: 1,
            });
            this.setState({
              showOtpModal: false,
              loader: false,
              isVerifiedPhoneNumber: true,
              nonVerifiedPhoneNumber: false,
            });
          } else {
            this.setState({
              otp_id: response.data.updateDetails.otp_id,
              showOtpModal: true,
              step: 2,
              addFundsLoader: false,
              renderTurnstileCaptcha: false,
              renderResendTurnstileCaptcha: false,
            });
          }
        } else {
          if (
            response?.errors &&
            response.errors?.[0]?.["message"] === "auth.request_limit_exceeded"
          ) {
            NotificationManager.error(
              "Limit exceeded, please try again in sometime. If it reoccurs, please reach out to cs@giift.com. Thank you for your patience.",
              "Error"
            );
          } else
            NotificationManager.error(
              "OTP not sent. Please try again!",
              "Error"
            );
          this.setState({
            addFundsLoader: false,
            renderTurnstileCaptcha: false,
            renderResendTurnstileCaptcha: false,
          });
        }
      }.bind(this)
    );
  };

  render() {
    const {
      accountReducer: {
        employeeDetails: { employee_email = "" } = {},
        kybStatus = {},
      } = {},
      is_proforma_invoice = 0,
      showAddCompanyAddressLoader,
    } = this.props;

    const {
      selectedPayment,
      formatedNetAmount,
      paymentGatewayFee,
      paymentGatewayFeePercent,
      formatedPaymentGatewayAmount,
      formatedtotal,
      showProformaModal,
      showProformsSuccess,
      proformaLoader,
      currencyCode,
      showCheckoutLoader,
      payPalButtonloader,
      payuResponse,
      markupPercent,
      formatedMarkupAmount,
      discountPercent,
      formatDiscountAmount,
      formatedGstAmount,
      gstAmount,
      gstPercent,
      companyAddress,
      selectedCountry,
      selectedState,
      selectedCity,
      loading,
      addAddresData,
      discountAmount,
      isPrimerOpen,
      primerModalFail,
      addFund,
      addFundError,
      showThresholdError,
      maxAmountError,
      razorpayMaxAMountError,
      payoneerMaxAMountError,
      addFundPrimerError,
      rechargeMaxLimitValue,

      phone_codes_ui,

      phnNumber,
      phnNumError,
      showOtpModal,
      isd_code_object,
      otpValue,
      otp_id,
      showResendMsg,
      invalidOtpMsg,
      showOtpLoading,
      addFundsLoader,

      otpAutoFocusTrigger,
      renderTurnstileCaptcha,
      renderResendTurnstileCaptcha,
    } = this.state;
    if (loading) {
      return <Loader />;
    }
    const threshold = kybStatus?.threshold;

    const {
      accountReducer: {
        companyDetails = {},
        employeeDetails = {},
        userBalance = {},
        moduleAcl = [],
        typeData = {},
        platformSettings: { showCompanyBalance = false } = {},
      } = {},
      moduleAclArray = [],
    } = this.props;

    const isCompanyAddressPresent =
      this.props.accountReducer?.companyDetails?.company_address1 ||
      !this.state.addAddresData;
    const redirectPage = this.state.rechargeState?.redirectPage;
    const title = isCompanyAddressPresent
      ? "Complete payment"
      : redirectPage
      ? "Enter details & send rewards"
      : "Enter your billing details";
    const subTitle = !isCompanyAddressPresent
      ? "Please enter your company details for billing purposes."
      : "Please select a payment method to complete adding funds to the wallet.";

    let helperText;
    helperText = maxAmountError
      ? maxAmountError
      : showThresholdError
      ? `
          ${currencyCode} ${threshold} is the limit up to which
          you can recharge your wallet until account
          verification is completed.
        `
      : null;
    const { accountReducer: { showCts = false } = {} } = this.props;

    return (
      <>
        {!this.state.razorpayModal ? (
          <StyledModal isOpen={true} padding={false} fullScreen>
            <div className="payment_">
              {isPrimerOpen ? (
                <>
                  {/* <div>
            <div
              className="goBack"
              style={goBackStyle}
              onClick={() => this.onPressBack()}
            >
              <img src="/admin/img/svg-icons/leftArrow1.svg" />
              <span>Back</span>
            </div>
          </div> */}
                  <Container>
                    <Row>
                      <Col
                        md={{
                          offset: 3,
                          size: 6,
                        }}
                        sm="12"
                      >
                        <div
                          id="checkout-container"
                          className="checkout-container"
                        ></div>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        md={{
                          offset: 3,
                          size: 6,
                        }}
                        sm="12"
                        className="company-details mt-2"
                      >
                        <Row>
                          <Col>Nreach Online Services Ltd.</Col>
                        </Row>
                        <Row>
                          <Col>Dog Patch Labs, Unit 1, The CHQ Building,</Col>
                        </Row>
                        <Row>
                          <Col>North Wall Quay, Dublin 1, D01 Y6H7</Col>
                        </Row>

                        <Row>
                          <Col className="mt-3">
                            Contact us via WhatsApp : +91 80 61915050{" "}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Container>
                </>
              ) : (
                <>
                  <div className="px-52 py-20 d-flex flex-row">
                    <Typography.H3>Add Funds to Wallet</Typography.H3>
                    <Icon
                      iconName="Close"
                      color="dark"
                      shade="c200"
                      size={16}
                      className="ml-auto"
                      onClick={() =>
                        isPrimerOpen
                          ? this.onPressBack()
                          : this.props.history.push(
                              redirectPage || `/${app_path}/recharge/`
                            )
                      }
                    />
                  </div>
                  <hr className="my-4" />
                  <div
                    className="d-flex flex-row"
                    style={{ padding: "41px 177px" }}
                  >
                    <div className="w-60 mr-40 mb-48" style={{ width: "60%" }}>
                      <div className="d-flex flex-column">
                        {kybStatus?.kyb_status !== 2 &&
                          kybStatus?.kyb_status !== 1 && (
                            <CustomCard spaceAround="6" className="mb-20">
                              <div className="d-flex flex-column">
                                <Typography.H2
                                  color="dark"
                                  shade="c300"
                                  className="mb-22"
                                >
                                  Enter Billing Details
                                </Typography.H2>
                                <SubmitKybForm
                                  {...this.props}
                                  typeData={typeData}
                                  companyDetails={companyDetails}
                                  employeeDetails={employeeDetails}
                                  userBalance={userBalance}
                                  loader={this.state.loader}
                                  update={this.updateCompanyBalance}
                                  handleShowCompanyBalance={
                                    this.handleShowCompanyBalance
                                  }
                                  setLoader={this.setLoader}
                                  kybStatus={kybStatus}
                                  history={this.props.history}
                                  updateCompanyDetails={
                                    this.props.updateCompanyDetails
                                  }
                                  isFromRecharge={this.state.isFromRecharge}
                                  updateEmployeeDetails={
                                    this.props.updateEmployeeDetails
                                  }
                                  getClientId={this.onGetClientId}
                                  countryOption={this.state.countryOption}
                                  cityOption={this.state.cityOption}
                                  stateOption={this.state.stateOption}
                                  selectedCountry={selectedCountry}
                                  selectedState={selectedState}
                                  selectedCity={selectedCity}
                                  getStateList={this.getStateList}
                                  getCityList={this.getCityList}
                                  addressLoading={this.state.addressLoading}
                                  countriesLoading={this.state.countriesLoading}
                                  statesLoading={this.state.statesLoading}
                                  citiesLoading={this.state.citiesLoading}
                                  phnNumber={phnNumber}
                                  phonecode={isd_code_object.phonecode}
                                />
                              </div>
                            </CustomCard>
                          )}
                        {!redirectPage && (
                          <CustomCard spaceAround="6">
                            <div>
                              <div className="d-flex flex-row">
                                <Typography.H2 color="dark" shade="c300">
                                  Enter Amount
                                </Typography.H2>
                                {this.state.rechargeState?.selectedWalletJson
                                  ?.subTitle ? (
                                  <div className="ml-auto d-flex flex-row align-items-center">
                                    <Typography.HelperText
                                      color="dark"
                                      shade="c300"
                                    >
                                      Current Balance:
                                    </Typography.HelperText>
                                    <Typography.LabelText className="ml-2">
                                      {
                                        this.props.accountReducer?.userBalance
                                          ?.currencyCode
                                      }{" "}
                                      {`${
                                        this.state.rechargeState
                                          ?.selectedWalletJson?.subTitle ||
                                        this.state.rechargeState
                                          ?.selectedWalletJson?.subTitle === 0
                                          ? Number(
                                              this.state.rechargeState
                                                ?.selectedWalletJson?.subTitle
                                            )
                                              ?.toFixed(2)
                                              .replace(
                                                /\d(?=(\d{3})+\.)/g,
                                                "$&,"
                                              )
                                          : Number(userBalance)
                                              ?.toFixed(2)
                                              .replace(
                                                /\d(?=(\d{3})+\.)/g,
                                                "$&,"
                                              )
                                      }`}
                                    </Typography.LabelText>
                                  </div>
                                ) : null}
                              </div>
                              <Input
                                id="recharge-amount-input-box"
                                autoFocus
                                className="w100 mt-24"
                                prefix={
                                  this.props.accountReducer?.userBalance
                                    ?.currencyCode
                                }
                                suffix={".00"}
                                placeholder="Enter your amount"
                                onChange={(e) => this.handleAmountChange(e)}
                                error={showThresholdError || maxAmountError}
                                value={
                                  addFund !== ""
                                    ? addFund
                                        ?.toLocaleString()
                                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                    : ""
                                }
                                helperText={helperText}
                              />
                            </div>
                          </CustomCard>
                        )}
                        <CustomCard
                          spaceAround="6"
                          className={redirectPage ? "" : "mt-20"}
                        >
                          <PaymentMethods
                            selectedPayment={selectedPayment}
                            initiatePaypal={() => this.initiatePaypalPayment()}
                            setPaymentMethod={(paymentMode) =>
                              this.setState({ selectedPayment: paymentMode })
                            }
                            redirectPage={
                              this.state?.rechargeState?.redirectPage
                            }
                            setRedirectPage={(redirectPage) =>
                              this.setState((prevState) => {
                                return {
                                  rechargeState: {
                                    ...prevState.rechargeState,
                                    redirectPage: redirectPage,
                                  },
                                };
                              })
                            }
                            currencyCode={currencyCode}
                            bankDetails={this.state.bankDetails}
                            poNumber={this.state.poNumber}
                            onChangePONumber={(e) =>
                              this.setState({ poNumber: e.target.value })
                            }
                            is_proforma_invoice={is_proforma_invoice}
                            kyb_status={kybStatus?.kyb_status}
                            setPaymentGateway={this.setPaymentGateway}
                            calculateAmount={this.calculateAmount}
                            handleAmountChange={this.handleAmountChange}
                            addFund={this.state.addFund || this.props.addFund}
                            allowOnlineTransfer={
                              this.props.accountReducer.allowOnlineTransfer
                            }
                            pgsLoading={this.state.pgsLoading}
                            pgs={this.state.pgs}
                            pgMap={this.state.pgMap}
                          />
                        </CustomCard>
                      </div>
                    </div>
                    <div
                      className="d-flex flex-column"
                      style={{
                        position: "fixed",
                        top: "116px",
                        right: "60px",
                      }}
                    >
                      <PaymentSummary
                        isCompanyAddressPresent={isCompanyAddressPresent}
                        submitAddressDetails={this.formValidation}
                        formatedNetAmount={formatedNetAmount}
                        paymentGatewayFee={paymentGatewayFee}
                        paymentGatewayFeePercent={paymentGatewayFeePercent}
                        formatedPaymentGatewayAmount={
                          formatedPaymentGatewayAmount
                        }
                        currencyCode={currencyCode}
                        formatedtotal={formatedtotal}
                        proformaInvoice={() => this.proformaInvoice()}
                        selectedPayment={selectedPayment}
                        handleOnlinePayment={(currencyCode) =>
                          this.handleOnlinePayment(currencyCode)
                        }
                        showCheckoutLoader={showCheckoutLoader}
                        payPalButtonloader={payPalButtonloader}
                        markupPercent={markupPercent}
                        formatedMarkupAmount={formatedMarkupAmount}
                        discountPercent={discountPercent}
                        formatDiscountAmount={formatDiscountAmount}
                        kybStatus={kybStatus}
                        accountReducer={this.props.accountReducer}
                        addAddresData={addAddresData}
                        is_proforma_invoice={is_proforma_invoice}
                        formatedGstAmount={formatedGstAmount}
                        gstAmount={gstAmount}
                        gstPercent={gstPercent}
                        discountAmount={discountAmount}
                        phnNum={this.state.phnNum}
                        showOtpModal={this.state.showOtpModal}
                        setPaymentState={this.setPaymentState}
                        companyAddress={companyAddress}
                        selectedCountry={selectedCountry}
                        selectedState={selectedState}
                        selectedCity={selectedCity}
                        nonVerifiedPhoneNumber={
                          this.state.nonVerifiedPhoneNumber
                        }
                        rechargeState={this.state.rechargeState}
                        calculateAmountLoader={this.state.calculateAmountLoader}
                        {...this.props}
                      />
                      {(kybStatus?.kyb_status == 2 ||
                        kybStatus?.kyb_status == 1) && (
                        <BillingDetails
                          accountReducer={this.props.accountReducer}
                          companyAddress={this.state.companyAddress}
                          isLoading={this.state.isAddressLoading}
                        />
                      )}
                    </div>
                  </div>

                  {showProformaModal ? (
                    <ProformaInvoice
                      headerTitle="Are you sure?"
                      modalStatus={() => {
                        this.proformaInvoice();
                      }}
                      proformaBody={
                        <div style={{ color: "#252a31" }}>
                          <div className="mb-4">
                            We will generate an invoice and send it to your
                            email address. You can make the payment later using
                            NEFT, IMPS or RTGS to the account number given on
                            the invoice.
                          </div>
                          <br />
                          <div>
                            The funds will be added to the account only after
                            payment is complete.
                          </div>
                        </div>
                      }
                      proformaLoader={proformaLoader}
                      disableCross={true}
                      buttonText={"Yes, Generate"}
                      btnText2="No, Cancel"
                      actionProformaHandler={() => {
                        this.generateInvoice();
                      }}
                      className="actionModalFooterRight"
                      poNumber={this.state.poNumber}
                    />
                  ) : null}

                  {showProformsSuccess ? (
                    <ProformaInvoice
                      headerTitle=""
                      headerClass="d-none"
                      proformaBody={
                        <div className="text-left">
                          <img src="/admin/img/svg-icons/icon-success-large.svg" />
                          <Typography.H2
                            color="dark"
                            shade="c300"
                            className="my-12"
                          >
                            Invoice generated successfully
                          </Typography.H2>
                          <Typography color="dark" shade="c200">
                            Your invoice has been generated and sent to{" "}
                            {employee_email}.
                          </Typography>
                        </div>
                      }
                      modalStatus={() => {
                        this.setState({
                          showProformsSuccess: false,
                          showProformaModal: false,
                        });
                      }}
                      disableCross={false}
                      topMargin="mt-48"
                      buttonText="OK, Got It"
                      actionProformaHandler={() => {
                        this.handleProformaSubmit();
                      }}
                      className="actionModalFooterRight pb-0"
                    />
                  ) : null}

                  {payuResponse ? (
                    <PayuForm payuResponse={payuResponse} />
                  ) : null}

                  <Modal
                    isOpen={this.state.stripeToken}
                    onClose={() =>
                      this.setState({
                        stripeToken: false,
                        showCheckoutLoader: false,
                      })
                    }
                    size="md"
                    disableCloseButton={true}
                    enableOverflow
                  >
                    {this.state.stripeToken && (
                      <EmbeddedCheckoutProvider
                        stripe={stripePromise}
                        options={{ clientSecret: this.state.stripeToken }}
                      >
                        <EmbeddedCheckout />
                      </EmbeddedCheckoutProvider>
                    )}
                  </Modal>
                </>
              )}
              <NotificationContainer />
              <Modal
                isOpen={primerModalFail}
                onClose={() => this.setState({ primerModalFail: false })}
                disableCloseButton={false}
              >
                <Typography.H2>CANCEL PAYMENT?</Typography.H2>

                <Typography className="mt-24">
                  Your payment is ongoing. Are you sure you want to cancel the
                  payment?
                </Typography>

                <div className="d-flex flex-end mt-24">
                  <Button
                    color="primary"
                    onClick={() => this.handleCancelPayment(redirectPage)}
                  >
                    Yes, Cancel
                  </Button>
                  <Button
                    color="primary"
                    variant="plain"
                    onClick={() => this.setState({ primerModalFail: false })}
                    className="ml-8"
                  >
                    No
                  </Button>
                </div>
              </Modal>
            </div>
            <BelowPanel>
              <Typography className="w-50 d-flex align-items-center justify-content-center mt-12">
                {kybStatus?.kyb_status === 0 || kybStatus?.kyb_status === 1 ? (
                  <Icon iconName="PlumInfo" size={16} className="mr-8" />
                ) : null}

                {kybStatus?.kyb_status === 0 ? (
                  <>
                    <Typography
                      color="blue"
                      shade="c02"
                      component="span"
                      className="mr-4 cursor-pointer"
                      onClick={() =>
                        this.props.history.push(
                          `/${app_path}/accounts/platform-preferences#submit-kyb`
                        )
                      }
                    >
                      Verify your business
                    </Typography>{" "}
                    to continue adding funds.
                  </>
                ) : kybStatus?.kyb_status === 1 ? (
                  <Typography color="dark" shade="c300" component="span">
                    Business verification is being processed.
                  </Typography>
                ) : (
                  ""
                )}
              </Typography>

              <Typography
                component="div"
                className="d-flex justify-content-end align-items-center w-100"
              >
                <Typography component="div" className="d-flex">
                  <Button
                    variant="plain"
                    color="primary"
                    className="mr-20"
                    onClick={() =>
                      isPrimerOpen
                        ? this.onPressBack()
                        : this.props.history.push(
                            redirectPage || `/${app_path}/recharge/`
                          )
                    }
                  >
                    {" "}
                    Cancel
                  </Button>

                  <div className="mr-40">
                    {selectedPayment && selectedPayment != 5 ? (
                      <>
                        <Button
                          onClick={() =>
                            !showCheckoutLoader
                              ? this.handleOnlinePayment(currencyCode)
                              : null
                          }
                          variant="fill"
                          color="primary"
                          disabled={
                            showCheckoutLoader ||
                            this.state.calculateAmountLoader ||
                            !addFund ||
                            kybStatus?.kyb_status !== 2 ||
                            maxAmountError
                          }
                          loading={
                            showCheckoutLoader ||
                            this.state.calculateAmountLoader
                          }
                        >
                          Proceed to Pay
                        </Button>
                      </>
                    ) : selectedPayment == 5 ? (
                      <>
                        <Button
                          onClick={() => this.proformaInvoice()}
                          variant="fill"
                          color="primary"
                          disabled={
                            showCheckoutLoader ||
                            this.state.calculateAmountLoader ||
                            !addFund ||
                            kybStatus?.kyb_status != 2 ||
                            maxAmountError
                          }
                          loading={
                            showCheckoutLoader ||
                            this.state.calculateAmountLoader
                          }
                        >
                          Generate Invoice
                        </Button>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </Typography>
              </Typography>
            </BelowPanel>

            {showOtpModal ? (
              <RechargeOtpModal
                showCts={showCts}
                renderResendTurnstileCaptcha={renderResendTurnstileCaptcha}
                showOtpModal={showOtpModal}
                closeModal={() => {
                  this.props.history.push(
                    this.state.rechargeState?.redirectPage ||
                      `/${app_path}/recharge`
                  );
                }}
                updateOtp={(otp) =>
                  this.setState({
                    otpValue: otp,
                    invalidOtpMsg: false,
                    showResendMsg: false,
                  })
                }
                otpValue={otpValue}
                isd_code_object={isd_code_object}
                validateOtp={() => this.handleValidateOtp()}
                resendOtp={(token) => this.handleResendOtp(token)}
                toggleRenderTurnstile={(value) =>
                  this.setState({ renderResendTurnstileCaptcha: value })
                }
                otp_id={otp_id}
                phnNumber={phnNumber}
                showResendMsg={showResendMsg}
                invalidOtpMsg={invalidOtpMsg}
                otpAutoFocusTrigger={otpAutoFocusTrigger}
                showOtpLoading={showOtpLoading}
                triggerFocus={(data) =>
                  this.setState({ otpAutoFocusTrigger: data })
                }
                handleSendOtp={this.handleSendOtp}
                handleISDchange={this.handleISDchange}
                handleMobileChange={this.handleMobileChange}
                phone_codes_ui={phone_codes_ui}
                phnNumError={phnNumError}
                accountReducer={this.props.accountReducer}
                addFundsLoader={addFundsLoader}
                getAddressDetailsLoader={this.props.getAddressDetailsLoader}
                redirectPage={this.state.redirectPage}
                step={this.state.step}
                setStep={this.setStep}
                renderTurnstileCaptcha={renderTurnstileCaptcha}
                handleGenerateRechargeOtp={this.handleGenerateRechargeOtp}
                disableCloseButton={false}
              />
            ) : null}
          </StyledModal>
        ) : null}
      </>
    );
  }
}

export default CreatePayment;
